import React from "react";
import { Link, useParams } from "react-router-dom";
import data from "../../json/News/News.json";

const Newsdetails = () => {
  const { id } = useParams();

  let news = data.news[id];

  let selectednews = data.news.filter((item, index) => item.id !== id);

  function getRandomElements(arr, count) {
    // Make a copy of the array to avoid modifying the original array
    let arrayCopy = [...arr];

    // Implementing Fisher-Yates shuffle algorithm
    for (let i = arrayCopy.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arrayCopy[i], arrayCopy[j]] = [arrayCopy[j], arrayCopy[i]]; // Swap elements
    }

    // Return the first 'count' elements from the shuffled array
    return arrayCopy.slice(0, count);
  }
  const gallery = data.gallery.find((item, i) => item.id == id) || {};

  return (
    <div className="w-full flex justify-center news-heighlight relative">
      <div className="2xl:container md:px-10 lg:px-20  px-6 py-10 sm:py-16 lg:py-20 flex flex-col justify-center w-full">
        <Link className=" " to={`/company/News`}>
          <p className="flex items-center gap-2 text-16 text-ctaorange font-semibold">
            <span>
              <img
                className="rotate-180"
                src={process.env.PUBLIC_URL + "/images/orangearrow.png"}
                alt="backarrow"
              />
            </span>
            GO BACK
          </p>
        </Link>
        <div className="pt-[40px] flex justify-center flex-col  lg:flex-row">
          <div className="flex flex-col w-full  lg:w-3/5 lg:mr-8">
            <div className="flex flex-col gap-4">
              <img
                className="rounded-[24px] lg:w-[80%]"
                src={process.env.PUBLIC_URL + news.img}
                alt={news.shortnews}
              />
              <p className="text-16 mt-2 md:text-18 text-orangeyellow font-medium">
                {news.date}
              </p>
              <div className="flex flex-col gap-2">
                <h1 className="text-24 sm:text-32 text-primarycolor  font-semibold ">
                  {news.shortnews}
                </h1>
                <p className="text-14 md:text-16 text-secondaryblack">
                  {news.destination}
                </p>
              </div>
              <p className="text-base mt-2 md:text-16 text-secondaryblack">
                {news.brief}
              </p>
            </div>
          </div>
          <div className="flex flex-col mt-12 sm:mt-16 w-full lg:mt-0  lg:w-2/5 lg:pl-6 lg:border-l-[2px]  border-journyborder ">
            <h1 className="text-24 font-medium text-primarycolor">
              Related News
            </h1>
            <div className="flex flex-col mt-8 lg:mt-10 gap-6 lg:max-h-[700px] overflow-y-auto scrollbar-none ">
              {data.news.map((item, ind) => (
                <div
                  key={ind}
                  className={`flex  p-4 sm:p-6 rounded-[16px] ${item.id == id ? "bg-gray" : "bg-white border border-journyborder"}`}
                >
                  <div className="flex flex-col gap-2 w-full ">
                    <p className="text-16 text-secondaryblack font-medium">
                      {item.date}
                    </p>
                    <p className=" text-18 font-medium text-primarycolor w-full">
                      {item.shortnews}
                    </p>

                    <Link
                      className=" mt-2 sm:mt-3"
                      to={`/company/Newsdetail/${item.id}`}
                    >
                      <p className="bio text-ctaorange flex items-center  text-16 sm:text-18 font-semibold">
                        Read More{" "}
                      </p>
                    </Link>
                  </div>
                  {/* <div className="w-4/12 rounded-[16px]">
                    <img
                      className="h-full w-full rounded-[16px] object-fit"
                      src={process.env.PUBLIC_URL + item.img}
                      alt="img"
                    />
                  </div> */}
                </div>
              ))}
            </div>
          </div>
        </div>

        {Object.keys(gallery)?.length ? (
          <div className="w-full p-[32px] md:p-[48px] rounded-[24px] shadow-products border border-jorneyborder mt-5">
            <h3 className="text-24 sm:text-32 md:text-48 text-primarycolor mb-10 font-semibold">
              Gallery
            </h3>
            <div className="flex gap-6 overflow-x-auto scrollbar-none flex-col items-center sm:flex-row ">
              {gallery.img.map((item, index) => (
                <div className="">
                  <img
                    key={index}
                    src={process.env.PUBLIC_URL + item}
                    alt="publishing news"
                  />
                </div>
              ))}
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default Newsdetails;
